import React, { useState,useEffect } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import vodunDaysLogo from '../assets/vodundays_logo.png';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useTranslation } from 'react-i18next'; 
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { useNavigate } from "react-router-dom";
import { CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../i18n';
import { useLanguage } from './LanguageContext';
import { useCart } from "../components/CartContext";



const Header = ({cartCount, supprimerArticle,  removeItemFromCart, emptyCart }) => { 
 

  
  const { t } = useTranslation();
          const { cart, setCart, setCartCount} = useCart();

  const [captchaVerified, setCaptchaVerified] = useState(false);
 
  const [open, setOpen] = useState(false); // Contrôle l'ouverture du Dialog
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false); // Gère l'état de soumission
  const [email, setEmail] = useState(''); // État pour l'email

  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true);
    } else {
      setCaptchaVerified(false);
    }
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault(); // Empêche le rechargement de la page


    setIsSubmitting(true); // Active l’état de chargement
    // const captchaToken = document.querySelector(".g-recaptcha-response").value;
 
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/shop/resend-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({ email }), // Envoie l’e-mail au backend
      });
      if (!response.ok) {
        if (response.status === 500) {
          // Redirection vers la page 500
          navigate("/500");
        }
        throw new Error(`Erreur HTTP : ${response.status}`);
      }
      if (response.ok) {
        Swal.fire({
          title: t("suucces"),
          text: t("textmail"),
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } else {

      Swal.fire({
        title: t("ereur"),
        text: t("enver"),
        icon: 'error',
        confirmButtonText: 'OK'
      });
      }
    } catch (error) {
      Swal.fire({
        title: t("ereur"),
        text: t("enver"),
        icon: 'error',
        confirmButtonText: 'OK'
      });
      // toast.error('Une erreur est survenue lors de l\'envoi.');
    } finally {
      setIsSubmitting(false); // Désactive le chargement
      setOpen(false); // Ferme le dialogue
    }
  };


  const { i18n } = useTranslation(); 
  // const [language, setLanguage] = useState(localStorage.getItem("language") || "FRA");
  const { language, changeLanguage } = useLanguage();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const languages = [
    { code: "FRA", label: "Français", flag: "https://flagcdn.com/16x12/fr.png" },
    { code: "ENG", label: "English", flag: "https://flagcdn.com/16x12/gb.png" },
    { code: "ESP", label: "Español", flag: "https://flagcdn.com/16x12/es.png" },
    { code: "POT", label: "Português" , flag: "https://flagcdn.com/16x12/pt.png"},
  ];

  const handleLanguageChange = (code) => {
    i18n.changeLanguage(code);  // Changer la langue de l'application
    changeLanguage(code);  // Mettre à jour l'état local de la langue
    localStorage.setItem("language", code);  // Sauvegarder la langue dans localStorage
  };

    useEffect(() => {
    // Si la langue est déjà dans le localStorage, l'appliquer au démarrage de l'application
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);  // Appliquer la langue sauvegardée
    }
  }, [i18n]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".language-selector")) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  // const toggleCart = () => setIsCartOpen(!isCartOpen);
  const closeCartDropdown = () => {
    setIsCartOpen(false);
  };

  // Calculer le total du panier

  const calculateTotal = () => {
    return cart.reduce((total, item) => total + item.price * item.quantity, 0);
  };



  /////////////////////////////////////////////////////////////////////////////////////////////////



  const lang = localStorage.getItem('language');
  let newlang = ""; // Utilisez let au lieu de const


  if (lang === "FRA") {
      newlang = 'FR';
  } else if (lang === "ENG") {
      newlang = 'EN';
  } else if (lang === "ESP") {
      newlang = 'ES';
  } else if (lang === "POT") {
      newlang = 'PT';
  }


  const translateText = async (text, targetLanguage) => {
    if (targetLanguage === 'FR') {
      return text; // Si la langue cible est déjà le français, ne traduisez pas.
    }

    const apiKey = process.env.REACT_APP_DEEPL_API_KEY;

    const url = process.env.REACT_APP_DEEPL_URL;

    const params = new URLSearchParams();
    params.append("auth_key", apiKey);
    params.append("text", text);
    params.append("target_lang", targetLanguage);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });

      const data = await response.json();

      if (data.translations && data.translations[0] && data.translations[0].text) {
        return data.translations[0].text;
      } else {
        return text; // Retournez le texte original si la traduction échoue
      }
    } catch (error) {
      return text; // Retournez le texte original en cas d'erreur
    }
  };
  
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
    // Ajoutez votre logique de gestion du panier ici
  };
  const [translatedCart, setTranslatedCart] = useState([]);

  const translateCartItems = async () => {
    const translatedItems = await Promise.all(
      cart.map(async (item) => {
        if (!item.name) {
          return item; // Si pas de nom, retournez l'élément tel quel
        }
        const translatedName = await translateText(item.name, newlang);
        const translatedType = await translateText(item.type, newlang); 
        return { ...item, name: translatedName, type: translatedType  };
      })
    );
    setTranslatedCart(translatedItems);
  };
  const location = useLocation(); // Obtenir l'URL actuelle

  useEffect(() => {
    // Fermer le dropdown du panier si l'URL change
    setIsCartOpen(false);
    setIsHovered(false);
  }, [location.pathname]); // Déclenche sur chaque changement de chemin d'URL


  useEffect(() => {
    if (cart.length > 0) {
      translateCartItems();
    }
  }, [cart, lang]);


  const viderPanier = async () => {
    // Videz le panier dans le localStorage
    // localStorage.setItem("cart", JSON.stringify([]));
    // localStorage.setItem("cartCount", "0");

    emptyCart();

    // // Réinitialisez les états locaux
    setCart([]);
    setCartCount(0);
  
    // // Réinitialisez `translatedCart`
    setTranslatedCart([]);
  
    // // Émettez un événement personnalisé
    const event = new CustomEvent("cartUpdated", { detail: { cart: [], cartCount: 0 } });
    window.dispatchEvent(event);
  
  };
  
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  return (
    <>
      <div className="top-bar">
      <span
        style={{ cursor: 'pointer'}}
        onClick={() => window.open('https://vodundays.bj', '_blank', 'noopener,noreferrer')}
      >
        VODUNDAYS
      </span>
        <div className="top-links">
        <a href="#" onClick={(e) => { e.preventDefault(); handleOpen(); }}>
          {t('top_bar.my_orders')}
        </a>
          <Link to="/FAQ">FAQ</Link>
          <div className="language-selector" onClick={() => setDropdownVisible(!dropdownVisible)} style={{ position: "relative", cursor: "pointer" }}>

                  <DropdownButton id="dropdown-basic-button" title={<><img src={languages.find(lang => lang.code === language).flag} alt={language} style={{ width: 20, height: 15, marginRight: 10 }} />{language}</>}>
            {languages.map((lang) => (
                <Dropdown.Item
                    key={lang.code}
                    onClick={() => handleLanguageChange(lang.code)}
                >
                    <img src={lang.flag} alt={lang.label} style={{ width: 20, height: 15, marginRight: 10 }} />
                    {lang.label}
                </Dropdown.Item>
            ))}
        </DropdownButton>
        </div>
    
        <Dialog open={open} onClose={handleClose}>
  <form onSubmit={handleSubmit}>
    <DialogTitle>VODUN DAYS</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {t("tdialo")}
      </DialogContentText>
      <TextField
        autoFocus
        required
        margin="dense"
        id="email"
        name="email"
        label="Adresse e-mail"
        type="email"
        fullWidth
        variant="standard"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} disabled={isSubmitting}>
        {t("fermer")}
      </Button>
      <Button
        type="submit"
        disabled={isSubmitting}
        startIcon={isSubmitting && <CircularProgress size={20} />}
      >
        {isSubmitting ? t("env_cours") : t("envoyer")}
      </Button>
    </DialogActions>
  </form>
</Dialog>
        </div>
      </div>
      <div className="ligne-wrapper">
        <hr className="ligne-droite" />
      </div>
      <header className="header">
      <Link to="/">
        <img src={vodunDaysLogo} alt="Vodun Days Logo" className="logo-image" />
      </Link>
        <button className="hamburger" onClick={toggleMenu}>
          ☰
        </button>
        {/* Navigation links */}
        <nav className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <li>
          <Link to="/"  onClick={() => setIsMenuOpen(false)}>{t('header.home')}</Link>
        </li>
        <li>
          <Link to="/tickets" onClick={() => setIsMenuOpen(false)}>{t('header.tickets')}</Link>
        </li>
        <li>
          <Link to="/produits"  onClick={() => setIsMenuOpen(false)}>{t('header.products')}</Link>
        </li>
        <li>
          <Link to="/tentes" onClick={() => setIsMenuOpen(false)}>{t('header.tents')}</Link>
        </li>
          <a 
            href="https://vodundays.bj/contact/"  
            target="_blank" 
            rel="noopener noreferrer" 
            onClick={() => setIsMenuOpen(false)}
            onMouseLeave={handleMouseLeave}
          >
            {t('header.contacts')}
          </a>
        </nav>
        <div
      className="cart-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="cart" onClick={toggleCart}>
        <FaShoppingCart className="cart-icon" />
        <span className="cart-count">{cartCount}</span> {/* Compteur dynamique */}
      </div>

      {/* Dropdown affiché lorsque isCartOpen ou isHovered */}
      {(isCartOpen || isHovered) && (
        <div className="cart-dropdown">
          {cart.length > 0 ? (
            <>
              <ul className="cart-items">
                {translatedCart.map((item) => (
                  <li key={item.id} className="cart-item">
                    <div className="item-details">
                      <img
                        src={
                          item.type === "tent" || item.type === "tenda"  || item.type === "tienda" 
                            ? require("../assets/tente.webp") // Chemin vers l'image par défaut
                            : `${process.env.REACT_APP_BASE_URL}/${item.img}`
                        }
                        alt={item.name}
                        className="item-img"
                      />
                      <p className="item-name">{item.name}</p>
                      <p className="item-quantity">
                     
                        {item.quantity} x  {Number(item.price).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA
                      </p>
                    </div>
                    <button
                      className="remove-item-btn"
                      onClick={() => {
                        if (translatedCart.length === 1 || cart.length === 1) {
                          viderPanier();
                        } else {
                          removeItemFromCart(item.id);
                        }
                      }}
                    >
                      ✖
                    </button>
                    <hr className="hrr"></hr>
                  </li>
                ))}
              </ul>
              <hr />
              <div className="cart-total">
                <strong>{t("header.total")}</strong>
                <strong>{Number(calculateTotal()).toLocaleString('fr-FR', { maximumFractionDigits: 0 })} FCFA</strong>
              </div>
              <Link
                to="/panier"
                className="view-cart-btn"
                
                onClick={() => {
                  setIsCartOpen(false); // Ferme explicitement le panier
                }}
              >
                {t("header.view_cart")}
              </Link>
            </>
          ) : (
            <p className="empty-cart-message">{t("header.empty_cart")}</p>
          )}
        </div>
      )}
    </div>

        {/* Cart dropdown */}
      </header>
      <hr className="ligne-droite" />
    </>
  );
};

export default Header;